<script lang="ts">
    import {onMount} from 'svelte'
    import {page} from '$app/stores'
    import {get} from '$lib/api'
    import {DoubleBounce} from 'svelte-loading-spinners'
    import colors from 'tailwindcss/colors.js'
    import EmployeeAvatar from '$lib/components/EmployeeAvatar.svelte'
    import EmploymentStatus from '$lib/components/EmploymentStatus.svelte'
    import {Button, Input, Label, Modal, TabItem, Tabs, Timeline, TimelineItem} from 'flowbite-svelte'
    import {BellSolid, ExclamationCircleOutline, IconSolid, InfoCircleOutline, UploadSolid} from 'flowbite-svelte-icons'
    import Typeahead from '$lib/components/Typeahead.svelte'
    import PageLayout from '$lib/components/PageLayout.svelte'
    import ContactCard from "$lib/partials/employee/ContactCard.svelte";
    import BasicInfo from "$lib/partials/employee/BasicInfo.svelte";
    import {saveEmployee} from "$lib/calls/employee";
    import EducationInfo from "$lib/partials/employee/EducationInfo.svelte";
    import EmployeePictures from "$lib/partials/employee/EmployeePictures.svelte";
    import Reminder from "$items/employee/Reminder.svelte";
    import TaxAndInsurance from "$lib/partials/employee/TaxAndInsurance.svelte";
    import BankAccount from "$lib/partials/employee/BankAccount.svelte";
    import dayjs from "dayjs";
    import EmployeeContract from "$lib/partials/employee/EmployeeContract.svelte";
    import NewContractModal from "$lib/partials/employee/NewContractModal.svelte";
    import {asValue} from "$lib/utils/lenkradDate";
    import {getEmailTemplates} from "$lib/calls/mail";
    import EmployeeEmailModal from "$lib/partials/employee/EmployeeEmailModal.svelte";

    export let areaOptions = []
    export let regionOptions = []
    export let statusOptions = [
        {name: 'Neue Bewerbung', value: 'candidate'},
        {name: 'Telefontermin gebucht', value: 'interviewee'},
        {name: 'Im Bewerbungsprozess', value: 'onboarding'},
        {name: 'Aktiv', value: 'active'},
        {name: 'Inaktiv', value: 'inactive'},
        {name: 'Freigestellt', value: 'sabbatical'},
    ]




    let timelineItems = [
        {
            title: 'Erstellt',
            type: 'important',
            userId: 574
        }
    ];

    let employee
    let originalEmployee

    let editing = false
    let reminderModal = false
    let reminderDate = ''
    let reminderText = ''
    let emailModal = false
    let emailFrom = ''
    let emailSubject = ''
    let emailTemplate = ''
    let emailTemplates:any[] = []
    let emailText = ''
    let ckEditor
    let emailAttachments = []
    let contractModal = false
    let photoUploadModal = false
    let photo = ''
    let photoDeleteModal = false
    let attachmentUploadModal = false
    let attachment = ''


    const updateEmployee = () => {
    }

    const submitReminder = () => {
        console.log('submit reminder', {
            date: reminderDate,
            text: reminderText,
        })
    }

    const openEmailModal = async () => {
        emailModal = true
    }

    const submitEmail = () => {
        console.log('submit email', {
            from: emailFrom,
            to: employee.email,
            subject: emailSubject,
            template: emailTemplate,
            text: emailText,
            attachments: emailAttachments
        })
    }

    let addEmailAttachment = () => {
        console.log('add email attachment')
    }



    let deletePhoto = () => {
        console.log('delete photo')
    }

    let submitAttachment = () => {
        console.log('submit attachment')
    }

    const createContract = () => {
        contractModal = true
    }

    onMount(async () => {
        employee = await get('/employee/' + $page.params.uuid)
        console.log({employee})
    })

    const startEditing = () => {
        editing = true
        originalEmployee = {...employee}
    }

    const stopEditing = () => {
        editing = false
        employee = {...originalEmployee}
    }

    function save() {
        employee = {...employee, ...saveEmployee(employee)}
        editing = false
    }

    const icons = [
        {type: 'info', icon: InfoCircleOutline, color: 'bg-primary-200 text-primary-600'},
        {type: 'important', icon: ExclamationCircleOutline, color: 'bg-red-200 text-red-600'},
    ]



</script>

<PageLayout path="/employee" pageBackgroundClass="bg-[#f3f6fa]" title={(employee?.firstName || '') + ' ' + (employee?.lastName || '')}>

    <div class="was-in-slot">
        {#if employee}
            <div class="py-2 flex flex-wrap gap-1">
                <Button
                        on:click={() => reminderModal = true}
                        color="primary"
                        size="xs">
                    <BellSolid
                            class="w-3 h-3 mr-2"/>
                    <span>
                        Reminder erstellen
                    </span>
                </Button>
                <Button
                        on:click={openEmailModal}
                        color="primary"
                        size="xs">
                    <Icon
                            name="envelope-solid"
                            class="w-3 h-3 mr-2"/>
                    <span>
                        E-Mail verfassen
                    </span>
                </Button>
                {#if editing}
                    <Button
                            on:click={stopEditing}
                            color="red"
                            size="xs">
                        <Icon
                                name="close-solid"
                                class="w-3 h-3 mr-2"/>
                        <span>
                            Bearbeiten abbrechen
                        </span>
                    </Button>

                    <Button
                            on:click={save}
                            class="bg-blue-500 hover:bg-blue-600"
                            size="xs">
                        <Icon
                                name="check-circle-solid"
                                class="w-3 h-3 mr-2"/>
                        <span>
                            Speichern
                        </span>
                    </Button>
                {:else}
                    <Button
                            on:click={startEditing}
                            color="yellow"
                            size="xs">
                        <Icon
                                name="pen-solid"
                                class="w-3 h-3 mr-2"/>
                        <span>
                            Bearbeiten
                        </span>
                    </Button>
                {/if}
                <Button
                        on:click={createContract}
                        color="primary"
                        size="xs">
                    <Icon
                            name="building-solid"
                            class="w-3 h-3 mr-2"/>
                    <span>
                        Arbeitsvertrag erstellen
                    </span>
                </Button>
            </div>
        {/if}
    </div>

    {#if employee}

            <div class="pt-2">
                <div class="flex flex-col lg:grid lg:grid-cols-3 xl:grid-cols-4 justify-between items-start w-full gap-10">
                    <div class="flex justify-start items-center w-full lg:col-span-2 xl:col-span-3">
                        <div class="w-full px-4 py-10 sm:mx-0 sm:rounded-lg">
                            <div class="flex flex-col md:flex-row w-full gap-4">
                                <div class="flex md:block ">
                                    <div class="rounded-full bg-white p-2 ">
                                        <EmployeeAvatar size="3xl" {employee} editable={editing}/>
                                    </div>
                                </div>
                                <div class="flex-1">
                                    {#if editing}
                                        <div class="grid grid-cols-6 xl:grid-cols-5 justify-between items-center w-full gap-x-6 gap-y-2 xl:-my-6">
                                            <Label for="firstName"
                                                   class="flex justify-end items-center col-span-2 xl:col-span-1">
                                                Vorname
                                            </Label>
                                            <Input
                                                    bind:value={employee.firstName}
                                                    id="firstName"
                                                    name="firstName"
                                                    class="col-span-4 xl:col-span-2 py-2"/>
                                            <div class="hidden xl:block col-span-2"></div>

                                            <Label for="lastName"
                                                   class="flex justify-end items-center col-span-2 xl:col-span-1">
                                                Nachname
                                            </Label>
                                            <Input
                                                    bind:value={employee.lastName}
                                                    id="lastName"
                                                    name="lastName"
                                                    class="col-span-4 xl:col-span-2 py-2"/>
                                            <div class="hidden xl:block col-span-2"></div>

                                            <Label for="area"
                                                   class="flex justify-end items-center col-span-2 xl:col-span-1">
                                                Einsatzbereich
                                            </Label>
                                            <div class="col-span-4 xl:col-span-2">
                                                <Typeahead
                                                        value={employee.area}
                                                        data={areaOptions}
                                                        inputClass="py-2"></Typeahead>
                                            </div>
                                            <div class="hidden xl:block col-span-2"></div>

                                            <Label for="region"
                                                   class="flex justify-end items-center col-span-2 xl:col-span-1">
                                                Region
                                            </Label>
                                            <div class="col-span-4 xl:col-span-2">
                                                <Typeahead
                                                        value={employee.region}
                                                        data={regionOptions}
                                                        inputClass="py-2"></Typeahead>
                                            </div>
                                            <div class="hidden xl:block col-span-2"></div>
                                        </div>
                                    {:else}
                                        <div>
                                            <div class="text-xl font-semibold text-gray-600">
                                                {employee?.firstName}
                                                {employee?.lastName}
                                            </div>
                                        </div>
                                        <div>
                                            {#if employee.area}
                                                {employee.area}
                                            {/if}
                                        </div>
                                        <div>
                                            {#if employee.region}
                                                Region:
                                                {employee.region}
                                            {/if}
                                        </div>
                                    {/if}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col justify-start items-start w-full gap-4 lg:col-span-1 xl:col-span-1">
                        <div class="w-full">
                            <div class="pb-4">
                                <div class="flex flex-wrap">
                                    <div class="flex-auto pt-6">
                                        <div class="text-sm leading-6 text-gray-900">
                                            Personalnummer
                                        </div>
                                        <div class="mt-1 text-base font-semibold leading-6 text-gray-900">
                                            <div class="text-4xl font-semibold text-gray-900">
                                                {employee.employeeNumber}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex flex-wrap">
                                    <div class="flex-auto pt-6">
                                        <Label for="status" class="text-sm leading-6 text-gray-900">
                                            Mitarbeiterstatus
                                        </Label>
                                        <div class="mt-1 text-base font-semibold leading-6 text-gray-900">
                                            {#if editing}
                                                <Typeahead
                                                        id="status"
                                                        bind:value={employee.employmentStatus}
                                                        data={statusOptions}/>
                                            {:else}
                                                <EmploymentStatus size="lg" value={employee.employmentStatus}/>
                                            {/if}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Tabs contentClass="pt-3">
                <TabItem title="Stammdaten" href="" open>
                    <div class="flex gap-5 ">
                        <article class="w-full xl:w-1/5 ">
                            <ContactCard bind:employee {editing}/>
                            <div class="my-3 grid">
                                <Button on:click={() => attachmentUploadModal = true}

                                        size="xs">
                                    <UploadSolid class="w-3 h-3 mr-2"/>
                                    <span> Anhang hinzufügen </span>
                                </Button>
                            </div>
                            <EmployeePictures bind:employee />
                        </article>
                        <div class="flex-1">


                            <div class="pb-3">
                                <Reminder bind:employee/>
                            </div>

                            <BasicInfo bind:employee {editing}/>
                            <div class="my-3">
                                <EducationInfo bind:employee {editing} />
                            </div>
                            <div class="my-3">
                                <TaxAndInsurance bind:employee {editing} />
                            </div>
                            <div class="my-3">
                                <BankAccount bind:employee {editing} />
                            </div>
                        </div>
                        <section class="w-64 pl-3">
                            {#if editing}
                                <div class="w-full rounded-lg bg-white shadow ring-1 ring-black ring-opacity-5 overflow-hidden divide-y divide-gray-300">
                                    <div class="flex w-full justify-between p-3 bg-gray-50">
                                        <div class="text-sm font-semibold text-gray-900 leading-6">
                                            Worklog hinzufügen
                                        </div>
                                    </div>
                                    <div class="flex flex-col lg:flex-row divide-gray-100 gap-6 px-2 py-2">
                                        <div class="flex flex-col gap-3 w-full">
                                        <textarea
                                                class="block w-full resize-none border-0 bg-transparent text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
                                                bind:value={employee.worklog}
                                                placeholder="Was hast du geändert?"></textarea>
                                        </div>
                                    </div>
                                </div>
                            {/if}
                            <div class="pt-3">
                                <Timeline order="vertical">
                                    {#each employee.timeline.sort((a, b) => b.createdAt.stamp - a.createdAt.stamp) as timelineItem}

                                        <TimelineItem
                                                title={timelineItem.type}
                                                date={dayjs(asValue(timelineItem.createdAt)).format('DD.MM.YYYY HH:mm')}>
                                            <svelte:fragment slot="icon">
                                            <span class="flex absolute -left-3 justify-center items-center w-6 h-6 {icons.find(x => x.type === timelineItem.type)?.color} rounded-full ring-8 ring-white">
                                                <IconSolid icon="{icons.find(x => x.type === timelineItem.type)?.icon}" class="w-3 h-3 " />
                                            </span>
                                            </svelte:fragment>
                                            <p class="mb-4 text-base font-normal text-gray-500">
                                                {@html timelineItem.content}
                                            </p>
                                        </TimelineItem>

                                    {/each}
                                </Timeline>
                            </div>

                        </section>
                    </div>
                </TabItem>
                <TabItem title="Vertrag / History">
                    <EmployeeContract bind:employee />
                </TabItem>
                <TabItem title="Dokumente"></TabItem>
                <TabItem title="Erfassung"></TabItem>
                <TabItem title="Dispo"></TabItem>
            </Tabs>


        <Modal
                title="Reminder erstellen"
                bind:open={reminderModal}>
            <form on:submit={submitReminder}>
                <div class="grid grid-cols-5 w-full gap-4">
                    <Label for="reminderText" class="flex justify-end items-center">
                        Erinnerung
                    </Label>
                    <Input
                            required
                            bind:value={reminderText}
                            id="reminderText"
                            name="reminderText"
                            class="col-span-4"
                            type="text"/>

                    <Label for="reminderDate" class="flex justify-end items-center">
                        Wecker
                    </Label>
                    <Input
                            required
                            bind:value={reminderDate}
                            id="reminderDate"
                            name="reminderDate"
                            class="col-span-4"
                            type="datetime-local"/>
                </div>
            </form>
            <svelte:fragment slot="footer">
                <Button on:click={submitReminder}>
                    Erstellen
                </Button>
                <Button
                        on:click={() => reminderModal = false}
                        color="alternative">
                    Abbrechen
                </Button>
            </svelte:fragment>
        </Modal>

        <EmployeeEmailModal bind:open={emailModal} bind:employee />
        <NewContractModal open={contractModal} bind:employee />



        <Modal
                title="Mitarbeiterfotos löschen"
                bind:open={photoDeleteModal}>
            <svelte:fragment slot="footer">
                <Button
                        on:click={() => photoDeleteModal = false}
                        color="alternative">
                    Abbrechen
                </Button>
            </svelte:fragment>
        </Modal>

        <Modal
                title="Anhang hinzufügen"
                bind:open={attachmentUploadModal}>
            <form>
                <Input
                        required
                        bind:value={attachment}
                        id="attachment"
                        name="attachment"
                        type="file"/>
            </form>
            <svelte:fragment slot="footer">
                <Button on:click={submitAttachment}>
                    <Icon
                            name="upload-solid"
                            class="w-3 h-3 mr-2"/>
                    Hochladen
                </Button>
                <Button
                        on:click={() => attachmentUploadModal = false}
                        color="alternative">
                    Abbrechen
                </Button>
            </svelte:fragment>
        </Modal>

    {:else}
        <DoubleBounce size="60" color={colors.cyan['300']} unit="px" duration="1s"/>
    {/if}

</PageLayout>
